"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsenceRequestDeletedMessage = void 0;
const model_1 = require("../model");
const utils_1 = require("../utils");
const base_html_1 = require("./base-html");
class AbsenceRequestDeletedMessage {
    get replyTo() {
        return this.employee.email;
    }
    get _startString() {
        return (0, utils_1.formatDate)(this.absence.start);
    }
    get _endString() {
        return (0, utils_1.formatDate)((0, utils_1.dateAdd)(this.absence.end, { days: -1 }));
    }
    constructor(vals) {
        Object.assign(this, vals);
    }
    get recipient() {
        return this.manager.email;
    }
    get title() {
        return `${this.absence.type === model_1.TimeEntryType.Vacation ? `Urlaubsantrag` : `Krankmeldung`} storniert von ${this.employee.name}: ${this._startString} bis ${this._endString}`;
    }
    get text() {
        return `
Hallo ${this.manager.firstName},

${`${this.employee.name} hat ${this.absence.type === model_1.TimeEntryType.Vacation ? "den Urlaubsantrag" : "die Krankmeldung"} für den Zeitraum ${this._startString} bis ${this._endString} storniert.`}

Der Antrag wurde automatisch aus dem System entfernt. Es ist keine weitere Aktion erforderlich.

Liebe Grüße,
Dein Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Hallo ${this.manager.firstName},`)}

            ${(0, base_html_1.paragraph)(`${this.employee.name} hat ${this.absence.type === model_1.TimeEntryType.Vacation ? "den Urlaubsantrag" : "die Krankmeldung"} für den Zeitraum ${this._startString} bis ${this._endString} storniert.`)}

            ${(0, base_html_1.paragraph)(`Der Antrag wurde automatisch aus dem System entfernt. Es ist keine weitere Aktion erforderlich.`)}

            ${(0, base_html_1.paragraph)(`
                Liebe Grüße,<br>
                Dein Pentacode Team
            `)}
        `);
    }
}
exports.AbsenceRequestDeletedMessage = AbsenceRequestDeletedMessage;
//# sourceMappingURL=absence-request-deleted.js.map